import TemporaryUserDeposit from './deposit'
export default TemporaryUserDeposit
